var parent = require('../../es/object/create');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/create.js
// module id = 1017
// module chunks = 0